import React from 'react';

import './styles.scss';

const SmallText = ({ children }) => <p className={'small-text'}>{children}</p>;

export default SmallText;
